// extracted by mini-css-extract-plugin
export var parcelRow = "_so-0";